import request from "@/utils/request"
import ElementUI, {
  Loading
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import App from './App.vue'
import './assets/gloable.css'
import router from './router'
import store from './store'

Vue.config.productionTip = false;
// Create global config object with environment variables
Vue.prototype.$config = {
  apiUrl: process.env.VUE_APP_API_URL,
  baseUrl: process.env.VUE_APP_BASE_URL
};

// Log the values to verify they're loaded
console.log('API URL:', process.env.VUE_APP_API_URL);
console.log('Base URL:', process.env.VUE_APP_BASE_URL);

Vue.use(ElementUI, {
  size: "mini"
});

Vue.prototype.request = request
Vue.use(VueAxios, request)
Vue.use(Loading.directive);
Vue.use(mavonEditor)

// 导航守卫
router.beforeEach((to, from, next) => {
  // 在这里进行全局操作，比如判断localStorage是否有用户信息
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null

  if (!user && to.path !== '/login') {
    // 如果没有用户信息且不是访问登录页面，则跳转到登录页面
    next('/login');
    // 在这里进行全局错误处理，例如显示一个错误提示
    Vue.prototype.$notify.error({
      title: '错误',
      message: '用户未登录'
    });
  } else {
    // 如果有用户信息或者访问登录页面，则继续导航
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')